// Module
var code = "<div class=\"tw-text-center landing-page-video\">\n    <vui-wistia-video-player class=\"landing-page-video__video\">\n        <ng-transclude></ng-transclude>\n    </vui-wistia-video-player>\n</div>\n";
// Exports
module.exports = code;